import styles from "./PageTypeA.module.css";

const PageTypeA = ({ title, subtitle, image }) => {
  return (
    <main className={styles.main}>
      <div className={styles.wrapper}>
        <div className={styles.imageWrapper}>
          <img className={styles.mainImage} src={image} alt="" />
        </div>
        <div className={styles.contentWrapper}>
          <h1 className={styles.title}>{title}</h1>
          <div className={styles.subtitleBtnWrapper}>
            <span className={styles.subtitle}>{subtitle}</span>
            <button type="button" className={styles.nextBtn}>
              next
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PageTypeA;
